import { Fragment, type ReactNode } from 'react';
import { Separator } from '@voll-intelligence/ui-kit/ui/separator';
import { FilterSection, SwitchFilterRow } from '../../shared/results_page/results_filters_panel.js';
import type { HotelResultsFiltersProps } from './hotel_results_filters.js';

/**
 * Os toggles binários do painel: política (o interruptor do protótipo) e as
 * tarifas café/cancelamento (itens 6/7, que o produto exige e o protótipo
 * ainda não desenha — entram na MESMA gramática de interruptor, porque cada um
 * é uma pergunta sim/não) e a tarifa acordo (#6928).
 *
 * Café e reembolso só aparecem se ALGUM offer souber o agregado; sem dado (o
 * fornecedor não o trouxe), a seção de tarifa some inteira em vez de oferecer um
 * corte que zera a lista. O acordo só aparece se ALGUM hotel carregado o tem —
 * cliente sem acordo não vê o filtro — ou se já está ligado, para nunca sumir
 * com o corte ativo. Fora do corpo do painel para ele não estourar o teto de
 * linhas.
 */
export function ToggleFilterSections({
  offers,
  value,
  copy,
  locked,
  onChange,
}: Pick<HotelResultsFiltersProps, 'offers' | 'value' | 'copy' | 'locked' | 'onChange'>): ReactNode {
  const hasBreakfastData = offers.some(({ hasBreakfast }) => hasBreakfast !== undefined);
  const hasRefundableData = offers.some(({ hasRefundable }) => hasRefundable !== undefined);
  const hasAgreedRate =
    value.agreedRateOnly === true || offers.some(({ agreedRate }) => agreedRate === true);
  return (
    <Fragment>
      <FilterSection title={copy.policyLabel}>
        <SwitchFilterRow
          label={copy.withinPolicyLabel}
          checked={value.policyOnly}
          disabled={locked}
          onChange={(policyOnly) => {
            onChange({ ...value, policyOnly });
          }}
        />
      </FilterSection>
      {(hasBreakfastData || hasRefundableData || hasAgreedRate) && (
        <Fragment>
          <Separator />
          <FilterSection title={copy.rateLabel}>
            <div className="grid gap-2">
              {hasBreakfastData && (
                <SwitchFilterRow
                  label={copy.breakfastLabel}
                  checked={value.breakfastOnly}
                  disabled={locked}
                  onChange={(breakfastOnly) => {
                    onChange({ ...value, breakfastOnly });
                  }}
                />
              )}
              {hasRefundableData && (
                <SwitchFilterRow
                  label={copy.refundableLabel}
                  checked={value.refundableOnly}
                  disabled={locked}
                  onChange={(refundableOnly) => {
                    onChange({ ...value, refundableOnly });
                  }}
                />
              )}
              {hasAgreedRate && (
                <SwitchFilterRow
                  label={copy.agreedRateLabel}
                  checked={value.agreedRateOnly === true}
                  disabled={locked}
                  onChange={(agreedRateOnly) => {
                    onChange({ ...value, agreedRateOnly });
                  }}
                />
              )}
            </div>
          </FilterSection>
        </Fragment>
      )}
    </Fragment>
  );
}
